module.exports = __webpack_public_path__ + "media/src/images/partners/auoas-9c41a29a8acdb94f5133597ccde6cb54.jpg";